module.exports = __webpack_public_path__ + "components/signup-page/static/icon-back-7a4c58d881f15b351a043b06ebae48ce.svg";